import { PlusIcon } from '@heroicons/react/24/outline';

import { cn } from '@/utils/tailwind';

export function AddFilterButton(props: {
  variant: 'v1' | 'v2';
  onClick: () => void;
  hasFilters: boolean;
  hideFilterTitle: boolean;
}) {
  return (
    <button
      type="button"
      className={cn(
        'flex cursor-pointer flex-row items-center gap-2 self-start rounded-md border border-secondary bg-primary p-1 px-2 transition-colors focus-within:bg-secondary hover:bg-secondary-hover active:bg-secondary',
        !props.hasFilters &&
          !props.hideFilterTitle &&
          'mt-1 justify-center self-stretch py-1.5',
        props.variant === 'v2' && props.hasFilters && 'px-2 py-0.5 text-xxs'
      )}
      onClick={props.onClick}
    >
      <PlusIcon className="h-4 w-4" />
      {props.hasFilters ? 'And' : 'Add filter'}
    </button>
  );
}
